/**
 * Ensures a URL string has an HTTP or HTTPS protocol
 * @param {string} url - The URL string to check
 * @returns {string} - The URL with https:// prepended if no protocol was present
 */
export const ensureHttpProtocol = (url) => {
    if (!url || typeof url !== 'string') return url;
    
    const trimmedUrl = url.trim();
    
    if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) {
        return trimmedUrl;
    }
    
    return `https://${trimmedUrl}`;
}
